import { useRouter } from "next/router"
import { useMenus } from "@/lib/contexts/appContext"

export default function useMenuItems(menuLocation = "primary") {
  const menus = useMenus()
  const { locale } = useRouter()

  if (!menus?.length) {
    return null
  }

  menuLocation = locale === "sv" ? menuLocation : `${menuLocation}-${locale}`

  const menuItems = menus.find((item) => item.location === menuLocation)

  return menuItems?.items && menuItems.items.length > 0 ? menuItems.items : null
}
